let Test = require('@/mixins/Forms/2022/NRCA_LTI_05_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            functional_test: {
                name: `B-2. Functional Testing by Verification of Systems Already Tuned (NA7.6.4.2.2)`,
                rows: {
                    row_1:{
                        id: `1`,
                        type: `Text`,
                        text: `Step 1: <b>Measurement of tuned lighting system </b> (Current measurements may be used instead of power measurements to show power reduction.)`,
                        code_reference: `NA7.6.4.2.2, Step 1`,
                    },
                    row_2:{
                        id: `--`,
                        type: 'Option',
                        question: `Select the used measurement Footcandles(<b>fc</b>), Amperes(<b>A</b>) or Watts(<b>W</b>)`,
                        options: [
                            'fc',
                            'W',
                            'A',
                        ],
                        code_reference: null,
                        answer: '',
                    },
                    row_3:{
                        id: `1.1`,
                        type: 'Text',
                        text: `Set all lighting controls except institutional tuning controls to provide maximum output of tested system. Controls set to maximum light output include but not limited to: manual dimmers, multilevel occupant sensing controls, and automatic daylighting controls.`,
                        code_reference: `NA7.7.5.2.2, Step 1(a), Section 140.6(a)2Jiii, Section 170.2(e)2Bxc`,
                    },
                    row_4:{
                        id: `1.2`,
                        type: 'Float',
                        question: `Measure the full light output at a location where most of the illuminance is due to the controlled lighting and enter the value in footcandles (fc). <b>OR</b> Measure the power of the controlled lighting and enter the value in watts (W). (If current measurements are being used, enter the measured current in amperes (A).)`,
                        code_reference: `NA7.6.4.2.2, Step 1(b)`,
                        answer:''
                    },
                    row_5:{
                        id: `2`,
                        type: `Text`,
                        text: `Step 2: <b>Measurement of lighting system with institutional tuning overridden</b>`,
                        code_reference: `NA7.6.4.2.2, Step 2`,
                    },
                    row_6:{
                        id: `2.1`,
                        type: 'Text',
                        text: `Reset institutional tuning controls to allow full light output. Set all lighting controls to provide maximum output of tested system including but not limited to: institutional tuning controls, manual dimmers, multilevel occupant sensing controls, and automatic daylighting controls.`,
                        code_reference: `NA7.6.4.2.2, Step 2(a)`,
                    },
                    row_7:{
                        id: `2.2`,
                        type: 'Float',
                        question: `Measure the light output at the same location as in Step 1.2 and enter the value in footcandles (fc). <b>OR</b> Measure the power of the same circuit as in Step 1.2 and enter the value in watts (W). (If current measurements are being used, enter the measured current in amperes (A).)`,
                        code_reference: `NA7.6.4.2.2, Step 2(b)`,
                        answer: '',
                    },
                    row_8:{
                        id: `2.3`,
                        type: 'Percentage',
                        question: `Calculate ratio of the light or power output of the system after institutional tuning to the light or power output of the system before institutional tuning and enter the value in %. [Step 1.2 / Step 2.2] x 100 `,
                        code_reference: null,
                        answer: '',
                    },
                    row_9:{
                        id: `2.4`,
                        type: 'BooleanResult',
                        question: `The light output or power after institutional tuning is 85% or less of the light output or power before institutional tuning. (Step 2.3 <= 85%) Enter yes (Y) or no (N).`,
                        code_reference: `NA7.6.4.2.2, Step 2(c), Section 140.6(a)2Ji, Section 170.2(e)2Bxa`,
                        answer: '',
                    },
                    row_10:{
                        id: `3`,
                        type: `Text`,
                        text: `Step 3: If the tested system passes the test in Step 2 (Step 2.4 = Y), restore institutional tuning settings`,
                        code_reference: `NA7.6.4.2.2, Step 2`,
                        questions: {}
                    }
                },
                result: false,
                comments: '',
            },
        }
    },

    methods: {

        functionalTestEvaluation() {

            if (!this.testIsReady) return;

            this.form.functional_test.result = true;

            var rows = this.form.functional_test.rows;

            // Steps
            // var s1Questions = steps.step_1.questions;
            // var s2Questions = steps.step_2.questions;

            if (!!rows.row_2.answer == false) {
                this.form.functional_test.result = false;
            }

            var row_1_2 = rows.row_4.answer;
            var row_2_2 = rows.row_7.answer;

            if (!this.isValidNumber(row_1_2) || !this.isValidNumber(row_2_2)) {
                this.form.functional_test.result = false;
                return;
            }

            var row_2_3 = (row_1_2 / row_2_2)

            if (!this.isValidNumber(row_2_3)) {
                this.form.functional_test.result = false;
                rows.row_8.answer = 0;
            } else {
                rows.row_8.answer = row_2_3;
            }

            var row_2_4 = rows.row_9.answer = (row_2_3 <= .85);

            if (row_2_4 == false) {
                this.form.functional_test.result = false;
            }
        },
    },
}
